import React from "react";
import { Helmet } from "react-helmet-async";

import { site } from "../../content/site";

export default function Seo({ title, description, image = "logo.png" }) {
  const pageTitle = title ? `${title} | ${site.name}` : site.name;
  const pageDescription = description || site.tagline;
  const url = typeof window !== "undefined" ? window.location.href : undefined;
  const imageUrl =
    typeof window !== "undefined"
      ? `${window.location.origin}/${String(image).replace(/^\//, "")}`
      : image;

  return (
    <Helmet>
      <title>{pageTitle}</title>
      <meta name="description" content={pageDescription} />

      {url ? <meta property="og:url" content={url} /> : null}
      <meta property="og:title" content={pageTitle} />
      <meta property="og:description" content={pageDescription} />
      <meta property="og:image" content={imageUrl} />

      <meta name="twitter:title" content={pageTitle} />
      <meta name="twitter:description" content={pageDescription} />
      <meta name="twitter:image" content={imageUrl} />
    </Helmet>
  );
}

